import React, { useEffect, useState } from "react";

export default function Dropdown({
  data,
  name,
  onChange,
  storageKey,
  defaultValue,
  description,
  className,
}: {
  data: string[];
  name: string;
  onChange: (key: string, value: any) => void;
  storageKey?: string;
  defaultValue?: string;
  description?: string | JSX.Element;
  className?: string;
}) {
  const [value, setValue] = useState(defaultValue || "");
  const useStorage = storageKey && typeof window.localStorage !== "undefined";

  useEffect(() => {
    if (useStorage) {
      let v = localStorage.getItem(storageKey as string) || defaultValue || "";
      setValue(v);
      onChange(name, v);
    } else {
      onChange(name, value);
    }
  }, []);

  return (
    <div className={"select rel " + (className || "")}>
      <select
        value={value}
        onChange={(e) => {
          if (useStorage) {
            localStorage.setItem(storageKey as string, e.target.value);
          }
          setValue(e.target.value);
          onChange(name, e.target.value);
        }}
      >
        {data.map((item) => {
          return (
            <option value={item} key={item}>
              {item}
            </option>
          );
        })}
      </select>
      {description && (
        <>
          <small className="op06 block mb1">{description}</small>
        </>
      )}
    </div>
  );
}
